let _lenis = null;

export const setLenis = (l) => {
  _lenis = l;
};

export const scrollToId = (target, opts = {}) => {
  if (_lenis) {
    _lenis.scrollTo(target, { offset: -10, duration: 1.4, ...opts });
  } else {
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  }
};
